import Logger from '@module/logger';

let dictionary = {};
let locale = 'en';
let locales = {
  en: ['English', 'English'],
};

export default class Dictionary {
  static get locale() {
    return locale;
  }

  static lookup(key) {
    if (!key) {
      throw 'NoTranslationKeyGiven';
    }

    // Get our dictionary
    let result = dictionary;
    if (!result) {
      throw 'TranslationDictMissing';
    }

    // Determine our key path
    const keys = key.split('.');
    for (const value of keys) {
      if (!result) {
        break;
      }
      result = result[value];
    }

    // No translation found for the key
    if (typeof result === 'undefined') {
      Dictionary.onMissingKey(key);
      return keys.pop();
    }

    return result;
  }

  static onMissingKey(key) {
    Logger.error(`Translation key missing: ${key}`);
  }

  static setLocales(list) {
    locales = list;
  }

  static get locales() {
    return locales;
  }

  static update(lang, dict = {}) {
    if (!locales[lang]) {
      throw 'InvalidLanguage';
    }

    // If something is wrong? :(
    if (!dict || typeof dict !== 'object') {
      throw 'InvalidDictionary';
    }

    locale = lang;
    dictionary = dict;
  }
}
